var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23661 15.3371C5.94698 15.4819 5.5415 15.8584 6.23661 16.206C7.1055 16.6404 8.40898 15.7715 7.97453 14.4682C7.54009 13.1649 6.23676 12.296 4.49898 13.1649C2.7612 14.0338 2.32646 18.8125 6.23661 18.8125C7.80544 18.8125 8.95461 18.253 9.71222 17.4707M14.0567 12.7301L17.9667 8.38571C18.4011 7.80645 18.8552 6.29145 18.4011 4.47571C17.9667 2.73837 15.36 0.565634 12.7533 1.4346C10.91 2.0491 10.5811 2.73786 9.27778 4.04187L2.86918 11.6065M14.0567 12.7301L29.2622 12.7302L21.0078 21.419H12.3188C11.4499 21.419 6.23667 21.8535 3.63002 20.5502C1.36691 19.4186 0.878538 16.4953 1.02335 14.9024C1.12966 14.1582 1.64181 12.7273 2.86918 11.6065M14.0567 12.7301L9.71222 17.4707M2.86918 11.6065C3.31373 11.2006 3.85209 10.8353 4.49898 10.558C7.54016 9.25471 9.71224 11.8614 10.5811 13.5992C11.1014 14.6397 10.8429 16.3033 9.71222 17.4707",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1270_59123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.697 6.21322C29.697 8.37266 27.9464 10.1232 25.787 10.1232M29.697 6.21322C29.697 4.05379 27.9464 2.30322 25.787 2.30322M29.697 6.21322H28.8281M25.787 10.1232C23.6275 10.1232 21.877 8.37266 21.877 6.21322M25.787 10.1232V9.25433M21.877 6.21322C21.877 4.05379 23.6275 2.30322 25.787 2.30322M21.877 6.21322H22.7458M25.787 2.30322V3.17211M24.9181 4.47544L25.787 6.21322L26.8731 6.86489",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1270_59123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4267,
    height: 10.4267,
    fill: "white",
    transform: "translate(20.5732 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIconBlack);
export default __webpack_public_path__ + "static/media/events_icon_black.efc003b4bf3355f60ec44cc625e4015d.svg";
export { ForwardRef as ReactComponent };